export const ACTIVITIES_PER_PAGE = 20
export const ACTIVITY_SORTING_OPTIONS = [
  {
    text: "Top Picks (default)",
    value: "default",
  },
  {
    text: "Rating (highest to lowest)",
    value: "rating_DESC",
  },
  {
    text: "Rating (lowest to highest)",
    value: "rating_ASC",
  },
  {
    text: "Difficulty (easiest to hardest)",
    value: "difficulty_ASC",
  },
  {
    text: "Difficulty (hardest to easiest)",
    value: "difficulty_DESC",
  },
  {
    text: "Time (shortest to longest)",
    value: "time_ASC",
  },
  {
    text: "Time (longest to shortest)",
    value: "time_DESC",
  },
  {
    text: "Distance (shortest to longest)",
    value: "distance_ASC",
  },
  {
    text: "Distance (longest to shortest)",
    value: "distance_DESC",
  },
  {
    text: "Elevation Gain (lowest to highest)",
    value: "elevation_gain_ASC",
  },
  {
    text: "Elevation Gain (highest to lowest)",
    value: "elevation_gain_DESC",
  },
]

export const difficulties = {
  "Very easy": 1,
  Easy: 2,
  Moderate: 3,
  Hard: 4,
  "Very hard": 5,
}
